export const applyFieldLogic = (fieldKey: string, value: any, formData: any): Record<string, any> => {
  const updates: Record<string, any> = {};

  // Cuando cambia la liga, limpiar todos los campos dependientes
  if (fieldKey === 'league') {
    updates.team1 = '';
    updates.player1 = '';
    updates.team2 = '';
    updates.player2 = '';
  }

  // Cuando cambia team1, limpiar player1
  if (fieldKey === 'team1') {
    updates.player1 = '';
  }

  // Cuando cambia team2, limpiar player2
  if (fieldKey === 'team2') {
    updates.player2 = '';
  }

  return updates;
};
